<template>
    <div>    
        <v-select
          :options="items"
          :filterable="false"
          @open="onOpen"
          @close="onClose"
          @search="search"
          :label="label"
          v-model="content"
          :placeholder="placeholder"
          :loading="items.length === 0"
        >
          <template #list-footer>
            <li v-show="hasNextPage" ref="load" class="loader">
              <slot name="loadingMore"></slot>
            </li>
          </template>
        </v-select>
    </div>
    
  </template>
  
  <style>
  .loader {
    text-align: center;
    color: #bbbbbb;
  }
  </style>
  
  <script>
  import _ from 'lodash'
  import VSelect from 'vue-select'

  export default {
    name: 'ProtokolInfiniteScroll',
    components: {
        VSelect
    },

    props: {
        value: {
            type: Object,
            default: () => {
                return null
            }
        },

        onFetch: {
            type: Function
        },

        placeholder: {
            type: String
        },

        perPage: {
            type: Number,
            default: 10
        },

        label: {
            type: String,
            default: "label"
        }
    },

    data: () => ({
      observer: null,
      page: 1,
      items: [],
      totalPages: 1,
      showModal: false,
      query: '',
      showAddItem: false
    }),
    
    computed: {
      hasNextPage() {
        return this.page < this.totalPages
      },
      
      content: {
          get() {
            return this.value
        },
        
        set(val) {
            this.$emit('input', val)
        }
      }
    },
    
    methods: {
      async onOpen() {
        if (this.hasNextPage) {
          await this.$nextTick()
          this.observer.observe(this.$refs.load)
        }
      },
      
      onClose() {
        this.observer.disconnect()
      },
      
      async infiniteScroll([{ isIntersecting, target }]) {
        if (isIntersecting) {
          const ul = target.offsetParent
          const scrollTop = target.offsetParent.scrollTop
          this.page += 1
          await this.$nextTick()
          ul.scrollTop = scrollTop
          this.search()      
        }
      },
      
      async _search(query) {
        if (query) {
            this.query = query
            this.page = 1
        }

        try {
            const { items = [], pages = 0 } = await this.onFetch(query, this.page);

            if (query) {
                this.items = items
            } else {
                if (this.items) {
                    this.items = this.items.concat(items)
                } else {
                    this.items = items
                }
            }

            this.totalPages = pages
        } catch(err) {
            this.$emit("onError", err)
        }
      }
    },
    
    mounted() {
      this.observer = new IntersectionObserver(this.infiniteScroll)
      this.search('')
    },
    created() {
        this.search = _.debounce((q) => this._search(q), 500)
    },
    beforeDestroy() {
        if (this.observer) this.observer.disconnect()
        if (this.search && this.search.cancel) this.search.cancel()
    },
  }
  </script>